import { NgModule } from "@angular/core";
import { BnComparacaoABModule } from "src/app/shared/modules/bn-comparacao.module";
import { SharedModule } from "src/app/shared/shared.module";
import { AbaOperacaoGarantidaComponent } from "./aba-operacao-garantida.component";

@NgModule({
    declarations: [AbaOperacaoGarantidaComponent],
    imports:[SharedModule,BnComparacaoABModule],
    exports:[AbaOperacaoGarantidaComponent]
})
export class AbaOperacaoGarantidaModule {}